var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"excel-download-button",attrs:{"href":_vm.href,"target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.windowPopupOpen.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('DOWNLOAD'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }